///<reference path="processEditor-module.ts"/>
///<reference path="process.ts"/>
///<reference path="popoverService.ts"/>
///<reference path="../../../typings/jqueryui/jqueryui.d.ts"/>

module ProcessEditor {
    'use strict';

    export function resizeOnEndpointMove() {
        function resizeCanvasSoElementFits($element: JQuery, canvasElement: ng.IAugmentedJQuery) : boolean {
            var resized = false;
            var elementHeight = $element.height();
            var elementWidth = $element.width();

            var currentCanvasHeight = canvasElement.height();
            var currentCanvasWidth = canvasElement.width();

            // set the height and height only if its the bigger than the default
            var newHeight = $element.position().top + elementHeight + 50;
            if (newHeight > currentCanvasHeight) {
                canvasElement.height(newHeight);
                resized = true;
            }

            var newWidth = $element.position().left + elementWidth + 50;
            if (newWidth > currentCanvasWidth) {
                canvasElement.width(newWidth);
                resized = true;
            }
            
            return resized;
        }

        return {
            restrict: "A",
            link: ($scope: ng.IScope, canvasElement: ng.IAugmentedJQuery) => {
                $scope.$on("changed.endpoint.frends", (event: ng.IAngularEvent) => {
                    $(canvasElement).find(".process-node, .process-scope").each((index, elem) => {
                        if(resizeCanvasSoElementFits($(elem), canvasElement)){
                            $scope.$emit("resized.scope.frends");
                        }
                    });
                });
            }
        }
    }

    app.directive("frendsResizeOnEndpointMove", [resizeOnEndpointMove]);
}